<template>
  <div v-inview-article="article">
    <component :is="contentComponent" />
  </div>
</template>
<script>
import store from 'nette-base-module/js/store'
import router from '@/router'
import $ from 'cash-dom'
// import context from '@/context'

export default {
  props: ['content', 'article'],
  directives: {
    inviewArticle: {
      mounted (el, binding) {
        if (!binding.value) return
        let articleInView = null
        el.pagingOnScroll = () => {
          const rect = el.getBoundingClientRect()
          const inView = (
            rect.width > 0 &&
            rect.height > 0 &&
            (
              (rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight)) ||
              (rect.bottom >= 200 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
            )
          )

          if (inView && !articleInView) {
            // window.removeEventListener('scroll', el.pagingOnScroll)
            articleInView = binding.value
            if (router.currentRoute.path !== articleInView.link) {
              // console.log('SELECTED article', binding.value, router)
              window.document.title = articleInView.header + ' | Svět Neziskovek'
              window.history.replaceState(null, articleInView.header, articleInView.link)
            }
          } else if (!inView && articleInView) {
            articleInView = null
          }
        }
        window.addEventListener('scroll', el.pagingOnScroll)
        // el.pagingOnScroll()
      },
      unmounted (el) {
        if (el.pagingOnScroll) {
          window.removeEventListener('scroll', el.pagingOnScroll)
          delete el.pagingOnScroll
        }
      }
    }
  },
  created () {
    if (typeof this.content === 'object' && this.content.storeData) {
      store.dispatch('nette/updateData', this.content.storeData)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fixArticle()
    })
  },
  computed: {
    contentComponent () {
      return {
        template: typeof this.content === 'object' ? this.content.html : this.content
      }
    }
  },
  methods: {
    fixArticle () {
      $(".img-left, .img-right, .article-detail img", this.$el).each(function() {
        var image = $(this);
        // pokud je obrazek v acku pridame acku tridu
        if(image.parent().is('a'))
          image.parent().addClass('image-link');

        if (image.closest('.author').length || image.closest('.poll').length || image.closest('.inner-article').length || image.closest('.image-w-caption').length)
          return;

        var imageCaption = image.attr("alt");
        if (imageCaption != '' && imageCaption) {
          image.one('load', function(){

            image.wrap('<div class="image-w-caption">');
            image.parent('.image-w-caption')
                .css('max-width', image.width())
                .addClass(image.attr('class'))
                .append('<div class="caption">'+imageCaption+'</div>');

          });

          if(this.complete || /*for IE 10-*/ image.height() > 0)
            image.trigger('load');
        }
      });

      var videoRegex = /^(https?:\/\/|\/\/)(www\.|m\.)?(youtube-nocookie|youtube\.googleapis|youtube|youtu|vimeo|player\.vimeo)+(\.be|\.com)/;

      $('iframe', this.$el).each(function(){
        var $iframe = $(this);
        if ($iframe.closest('.video-container').length)
          return;

        if (videoRegex.test($iframe.attr('src'))) {
          $iframe.wrap('<div class="video-container"></div>');
        } else {
          $iframe.attr('width', '100%');
        }
      });
    }
  }
}
</script>